export default __webpack_public_path__ + "static/media/Landing1.dee70252.jpeg";